import {
  Column,
  CreateDateColumn,
  Entity,
  Index,
  OneToMany,
  PrimaryColumn,
  UpdateDateColumn,
} from 'typeorm';
import { AccountEntity } from './account.entity';

/**
 * User entity for social login linking.
 * The id is the umsGuid - it must be provided when creating a user, not auto-generated.
 * Users are only added to this table when they use social login (signup or linking).
 */
@Entity({ name: 'users' })
@Index(['bcCustomerId'])
export class UserEntity {
  @PrimaryColumn({ type: 'varchar' })
  id!: string;

  @Column({ type: 'integer' })
  bcCustomerId!: number;

  @OneToMany(() => AccountEntity, (account) => account.user)
  accounts!: AccountEntity[];

  @Column({ type: 'timestamptz', nullable: true })
  verifiedAt!: Date | null;

  @CreateDateColumn({ type: 'timestamptz' })
  createdAt!: Date;

  @UpdateDateColumn({ type: 'timestamptz' })
  updatedAt!: Date;
}
